import { Card, Skeleton } from '@/components/ds-zta';

// Loading shape of a cloud provider's card grid: the page header stays put and
// three placeholder cards hold the grid's place while the first page loads.
// Shared by the AWS, Azure, GCP and Hetzner resource pages (design evaluation F41).
export default function CardGridSkeleton({ label }: { label: string }) {
  return (
    <div role="status" aria-busy="true" aria-label={label} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {[0, 1, 2].map((i) => (
        <Card key={i} aria-hidden="true">
          <div className="p-6 flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <Skeleton width={40} height={40} radius={8} />
              <div className="flex-1 flex flex-col gap-2">
                <Skeleton variant="text" width="60%" />
                <Skeleton variant="text" width="40%" />
              </div>
            </div>
            <Skeleton height={36} radius={8} />
            <Skeleton height={36} radius={8} />
          </div>
        </Card>
      ))}
    </div>
  );
}
